import { Col, Row } from 'antd';
import React from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import TranslateText from 'components/hoc/TranslateText';
import LeiLoginlessFooter from 'components/molecules/Lei/zadostLeiLoginless/LeiLoginlessFooter';
import LeiLoginlessMenu from 'components/molecules/Lei/zadostLeiLoginless/LeiLoginlessMenu';

const InfoLei: React.FC = () => {
    return (
        <>
            <LeiLoginlessMenu />
            <Row
                id="infoLei"
                style={{
                    paddingTop: 24,
                    paddingBottom: 24,
                    display: 'block',
                    background: 'white'
                }}
            >
                <div
                    style={{
                        margin: '0 auto',
                        maxWidth: 1200
                    }}
                >
                    <Col
                        style={{
                            display: 'block',
                            paddingLeft: 20,
                            maxWidth: 800,
                            background: 'white'
                        }}
                    >
                        <h1
                            style={{
                                color: '#007777'
                            }}
                        >
                            Co je kód LEI
                        </h1>
                        <p>
                            Identifikátor právnické osoby (LEI) je alfanumerický kód skládající se z 20 znaků, založený
                            na mezinárodní normě ISO 17442, který umožňuje jednoznačně identifikovat právnické osoby
                            (Legal Entities) působící na finančních trzích po celém světě. LEI (Legal Entity Identifier)
                            kód, dává podnikům jasnou identitu v globálním finančním prostředí. Jedná se o exkluzivní
                            značku, kterou nelze převést z jedné entity na druhou, což přidává další úroveň
                            transparentnosti mezinárodnímu obchodu. Jednoduše řečeno, je to identifikátor vašeho podniku
                            na světovém trhu. Naše společnost je oficiálním operátorem (LOU, Local Operating Unit),
                            který je již více než 12 let akreditován organizací GLEIF (Global Legal Entity Identifier
                            Foundation) pro přidělování kódů LEI.
                        </p>
                        <p>
                            Kód LEI obsahuje některé základní informace o právnické osobě (údaje úrovně 1), jako je
                            daňové identifikační číslo, název, adresa sídla, právní forma.
                        </p>
                        <p>
                            Dále obsahuje také informace týkající se korporátní struktury žadatele, tj. kdo je
                            vlastníkem koho (údaje úrovně 2), což je zvláště užitečné pro rekonstrukci korporátních
                            vazeb.
                        </p>
                        <p>
                            Všechny tyto údaje jsou zveřejňovány v databázi LEI, denně aktualizovány a dostupné na
                            webových stránkách GLEIF (Global Legal Entity Identifier Foundation), neziskové organizace,
                            která koordinuje globální systém LEI po celém světě, a mohou být volně konzultovány kýmkoli,
                            kdo má zájem, prostřednictvím příslušné funkce vyhledávání.
                        </p>

                        <h2 id="1">K čemu slouží</h2>
                        <p>
                            Kód LEI slouží k identifikaci protistran ve finančních transakcích podléhajících ohlašovací
                            povinnosti jednoduchým, rychlým a standardizovaným způsobem. Kód LEI je jedinečně přiřazen
                            každému žadateli a nelze jej převést z jedné právnické osoby na druhou.
                        </p>
                        <h2 id="1">Kdo jej potřebuje</h2>
                        <p>
                            Kód LEI je povinný pro právnické osoby, které obchodují s finančními nástroji (například s
                            akciemi, dluhopisy, opčními listy, státními dluhopisy a deriváty).
                        </p>
                        <h2 id="1">Jak jej získat</h2>
                        <p>
                            V České republice lze kód LEI rychle a snadno vyžádat prostřednictvím portálu stránek naší
                            společnosti nebo portálu Můj depozitář (pro zalogované uživatele).
                        </p>

                        <h3 id="1">
                            Žádost o přidělení/prodloužení kódu LEI se skládá z několika kroků a probíhá zcela online:
                        </h3>

                        <ul>
                            <li>Vyplnění žádosti</li>
                            <li>
                                Doložení plné moci (v případě, že o LEI žádá zprostředkovatel jménem právnické osoby)
                                vzor PM viz níže
                            </li>
                            <li>Platba kreditní kartou nebo bankovním převodem</li>
                            <li>Odeslání žádosti</li>
                        </ul>
                        <AnchorComponent
                            id="downloadPlnaMocBtn"
                            href={
                                window.location.href.includes('test')
                                    ? 'https://test.cdcp.cz/wp-content/uploads/md/LEI-plnaMoc.pdf'
                                    : 'https://www.cdcp.cz/wp-content/uploads/md/LEI-plnaMoc.pdf'
                            }
                            download="Lei plná moc.pdf"
                            target="_blank"
                        >
                            <TranslateText>
                                Stáhnout přílohu Formulář plné moci pro první aktivaci a obnovení
                            </TranslateText>
                        </AnchorComponent>
                        <h2 id="1">Jak dlouho platí</h2>
                        <p>Kód LEI platí po dobu jednoho roku od data vydání / od obnovení.</p>
                        <h2 id="1">Proč obnovit svůj kód LEI</h2>
                        <p>
                            Kód LEI má platnost jeden rok od svého prvního vydání a jeho každoroční obnovení je důležité
                            pro zachování přesnosti a aktuálnosti informací s ním spojených. Proces obnovení zajišťuje
                            transparentnost finančního trhu tím, že správně identifikuje subjekty, které na něm působí.
                        </p>
                        <h2 id="1">Jak obnovit svůj kód LEI</h2>
                        <p>
                            Pokud jste v minulosti aktivovali nebo obnovili kód LEI, obdržíte automatické oznámení
                            e-mailem, že se blíží expirace. Následně můžete požádat o prodloužení platnosti pomocí
                            přímého odkazu, který naleznete v emailu. Kód LEI lze prodloužit rovněž prostřednictvím
                            našich www stránek nebo po příhlášení do portálu Můj depozitář. Pro usnadnění . Tímto
                            způsobem můžete zajistit, že váš kód LEI neztratí platnost.
                        </p>
                        <h2 id="1">Proč si vybrat Centrální depozitář cenných papírů.</h2>
                        <p>
                            <strong>
                                Centrální depozitář cenných papírů, a. s., je akreditovaným poskytovatelem služby pro
                                přidělení a správu identifikátoru LEI. Naše společnost plní roli lokálního operátora
                                (LOU), v rámci globální sítě poskytovatelů služby LEI s oficiální akreditací pro
                                poskytovat služeb LEI v České republice a v dalších 19 evropských zemích.
                            </strong>
                            CDCP, a. s. patří mezi největší poskytovatele služeb LEI na světě a je první v České
                            republice v oblasti správy kódů LEI. Poskytuje vysoce kvalitní a spolehlivé služby.
                        </p>
                        <p>
                            Díky připojení v reálném čase k rejstříku společností – oficiálnímu registru všech českých
                            společností– je postup ověřování totožnosti těch, kteří žádají o kód LEI od CDCP, jednoduchý
                            a umožňuje vám získat kód ve velmi krátké době. Také při obnově kódu LEI vám přímé propojení
                            s rejstříkem společností umožňuje ještě rychlejší a snadnější způsob ověření informací v
                            databázi LEI a potvrzení žádosti o obnovení.
                        </p>
                        <h2 id="1">Legislativa</h2>
                        <p>Přijetí kódu LEI se řídí různými evropskými předpisy.</p>
                        <p>
                            Prvním aktem bylo nařízení EMIR (č. 684/2012/EU), které v Evropě zavedlo povinnost hlásit
                            podrobnosti týkající se transakcí prováděných s derivátovými finančními nástroji (ať už se
                            jedná o produkty kótované na regulovaných trzích nebo OTC) orgánům dohledu (v případě Itálie
                            Consob).
                        </p>

                        <p>Následovaly dva regulační zásahy, které důsledně rozšířily povinný rozsah kódu LEI:</p>

                        <ul>
                            <li>směrnice Společenství MIFID II (2014/65/EU) o trzích s finančními nástroji</li>
                            <li>související prováděcí nařízení MIFIR (600/2014).</li>
                        </ul>
                        <p>
                            S cílem vytvořit jednotný evropský trh finančních služeb má tato legislativa mezi svými
                            hlavními cíli zvýšení transparentnosti trhů a jejich dohledu, ochranu investorů a zlepšení
                            strategií provádění transakcí.
                        </p>
                        <p>
                            Od 3. ledna 2018, s vstupem v platnost směrnice MIFID II / MIFIR, musí mít všechny právnické
                            osoby, které si otevřely účet cenných papírů u finančních zprostředkovatelů, kód LEI.
                        </p>

                        <h2 id="1">Co jsou místní provozní jednotky (LOU)</h2>
                        <p>
                            LOU (místní provozní jednotky) jsou organizace oprávněné vydávat kódy LEI právnickým osobám,
                            které se účastní finančních transakcí. LOU se zabývají registrací a obnovou kódů LEI,
                            poskytují doplňkové služby a jsou hlavním kontaktním místem pro ty, kteří žádají o vydání
                            kódů LEI.
                            <br />
                            Akreditace je proces, kterým GLEIF (Global Legal Entity Identifier Foundation) posuzuje
                            vhodnost organizací, které chtějí v rámci globálního systému LEI působit jako vydavatelé
                            kódů LEI a správci údajů o právnických osobách.
                        </p>
                        <h2 id="1">Iniciativa „Policy Conformity Flag“ v globálním systému LEI</h2>
                        <p>
                            Policy Conformity Flag dále zvyšuje účinnost LEI tím, že poskytuje konkrétní příležitost k
                            podpoře a prosazování větší transparentnosti finančních transakcí. Údaje týkající se
                            právnických osob jsou zpřístupňovány veřejnosti otevřeným, standardizovaným a vysoce
                            kvalitním způsobem, což maximalizuje transparentnost a důvěru mezi účastníky trhu. <br />{' '}
                            Policy Conformity Flag je jednoduchý a jasný nástroj, který umožňuje všem zainteresovaným
                            stranám určit, které záznamy LEI (tj. soubor údajů týkajících se kódu LEI) splňují určité
                            zásady Regulačního dozorčího výboru (ROC). ROC koordinuje a dohlíží na globální systém LEI.
                            Záznam LEI označený jako „vyhovující“ znamená, že jsou splněna následující kritéria:
                            Registrace LEI je aktuální – obnovení záznamu LEI (a tedy i přezkoumání údajů týkajících se
                            právnické osoby) bylo dokončeno ve stanovené lhůtě. <br />
                            Prohlášení o údajích o struktuře společnosti je úplné – právnická osoba poskytla údaje o
                            přímých a konečných mateřských společnostech (nebo uvedla jeden ze stanovených důvodů, proč
                            tyto údaje nemohou být poskytnuty).
                        </p>
                        <h2 id="5">Osvědčení o akreditaci</h2>

                        <p>
                            Centrální depozitář cenných papírů, a. s., je akreditován organizací{' '}
                            <a rel="noreferrer noopener" href="https://www.gleif.org/" target="_blank">
                                Global Legal Entity Identifier Foundation (GLEIF)
                            </a>{' '}
                            a je{' '}
                            <a
                                rel="noreferrer noopener"
                                href={
                                    window.location.href.includes('test')
                                        ? 'https://test.cdcp.cz/wp-content/uploads/CSDP_Certificate.gif'
                                        : 'https://www.cdcp.cz/wp-content/uploads/CSDP_Certificate.gif'
                                }
                                target="_blank"
                            >
                                držitelem osvědčení o akreditaci
                            </a>
                            . Akreditované jurisdikce pro poskytování LEI naleznete v tomto{' '}
                            <a
                                href={
                                    window.location.href.includes('test')
                                        ? 'https://test.cdcp.cz/wp-content/uploads/CDCP_Akreditovane_jurisdikce_LEI.pdf'
                                        : 'https://www.cdcp.cz/wp-content/uploads/CDCP_Akreditovane_jurisdikce_LEI.pdf'
                                }
                            >
                                seznamu
                            </a>
                            .
                        </p>

                        <figure>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <a href="https://www.gleif.org/" target="_blank" rel="noopener">
                                                <img
                                                    decoding="async"
                                                    src={
                                                        window.location.href.includes('test')
                                                            ? 'https://test.cdcp.cz/wp-content/uploads/gleif-logo.png'
                                                            : 'https://www.cdcp.cz/wp-content/uploads/gleif-logo.png'
                                                    }
                                                    alt="GLEIF Logo"
                                                />
                                            </a>
                                        </td>
                                        <td>
                                            <a
                                                href={
                                                    window.location.href.includes('test')
                                                        ? 'https://test.cdcp.cz/wp-content/uploads/CSDP_Certificate.gif'
                                                        : 'https://www.cdcp.cz/wp-content/uploads/CSDP_Certificate.gif'
                                                }
                                                target="_blank"
                                                rel="noopener"
                                            >
                                                <img
                                                    decoding="async"
                                                    src={
                                                        window.location.href.includes('test')
                                                            ? 'https://test.cdcp.cz/wp-content/uploads/gleif-accredited-logo.png'
                                                            : 'https://www.cdcp.cz/wp-content/uploads/gleif-accredited-logo.png'
                                                    }
                                                    alt="Accredited Logo"
                                                />
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </figure>
                    </Col>
                </div>
            </Row>{' '}
            <LeiLoginlessFooter />
        </>
    );
};

export default InfoLei;
